import { gql } from '@apollo/client';

export const PRICE_PREDICTION_FOR_ITALY = gql`
  query getPricePredictionForItaly(
    $eurotaxCodes: [String!]
    $vehicleKM: Int
    $vendorType: VendorType
    $areListingsFromVendorExcluded: Boolean
    $vehicleRegistrationDateISO8601: String
    $vehicleOptionals: [String!]
  ) {
    getPricePredictionForItaly(
      eurotaxCodes: $eurotaxCodes
      vehicleKM: $vehicleKM
      vendorType: $vendorType
      areListingsFromVendorExcluded: $areListingsFromVendorExcluded
      vehicleRegistrationDateISO8601: $vehicleRegistrationDateISO8601
      vehicleOptionals: $vehicleOptionals
    ) {
      success
      predictedPrice
      lowerboundPredictedPrice
      upperboundPredictedPrice
      vehicleKM
      detectedVehicleModelVersions
      referenceArea
      geoPoint {
        latitude
        longitude
      }
      vehicleRegistrationDateISO8601
      averageListingDurationInDays
    }
  }
`;
